<template>
    <a-card>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #titles="{ record }">
                <a :href="record.url">{{ record.title }}</a>
             </template>
            <template #type="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['collecttype']" :text="text"></dict-render>
                </a-tag>
            </template>
        </a-table>
    </a-card>
</template>

<script>
import {collectApi} from "@/api/innovationService";
import {tableListMixin,dictMixin} from "@/mixins";
import DictRender from "@/components/other/DictRender";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "收藏标题", dataIndex: "title", key: "title",slots:{customRender: "titles"}},
    {title: "收藏时间", dataIndex: "createdTime", key: "createdTime", customRender: defaultDateCustomRender},
    {title: "收藏类型", dataIndex: "type", key: "type",slots:{customRender: "type"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},

];
export default {
    name: "index",
    mixins: [tableListMixin,dictMixin],
    components: {
        DictRender
    },
    data() {
        return {
            dictNames: 'collecttype',
            columns,
            queryParamFixed: {
                systemType:'finance'
            },
            listKeyField: "id",
            listUrl:collectApi.pageList
        }
    },
    mounted() {
    },
    methods: {}
}
</script>

<style scoped>

</style>
